const topics = [
  { name: '社会热点', count: '12.8万', hot: true },
  { name: '娱乐圈爆料', count: '9.6万', hot: true },
  { name: '科技行业', count: '8.3万', hot: true },
  { name: '金融动态', count: '7.5万', hot: false },
  { name: '房产楼市', count: '6.2万', hot: false },
  { name: '教育话题', count: '5.9万', hot: false },
  { name: '医疗健康', count: '5.4万', hot: false },
  { name: '汽车行业', count: '4.8万', hot: false },
  { name: '互联网圈', count: '11.2万', hot: true },
  { name: '消费维权', count: '4.1万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-secondary-600 uppercase tracking-wider">
            话题标签
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            热门话题标签
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            按话题浏览51爆料网最新内容，发现您感兴趣的爆料领域
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2.5 px-5 py-3 rounded-full border transition-all cursor-pointer ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 text-primary-700'
                  : 'bg-background-50 border-background-200 hover:border-background-300 hover:bg-background-100 text-foreground-700'
              }`}
            >
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse shrink-0"></span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className={`text-xs font-label font-medium ml-1 ${
                topic.hot ? 'text-primary-400' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}